__turbopack_context__.v({
  "colorPicker": "Header-module__rP_oDa__colorPicker",
});
